export const ROLE = {
  admin: '/admin/inicio',
  company: '/empresa/inicio',
  manager: '/gestor-entregas/inicio',
  driver: '/motorista',
  attendant: '/atendente/inicio',
}
